import _ from 'lodash'

import { CompanyService } from '@/services/retailer/CompanyService'

import { errorMessage, build_query } from '@/utilities/helpers.js'

import { COMPANY_ERROR_MESSAGES } from '@/constants/errorMessages'

export const namespaced = true

export const allowedFilters = ['id', 'by_company_name_or_tin']

export const allowedIncludes = 'farmers'

export const allowedSorts = 'id,name,-created_at'

export const state = {
  companies: null,
  meta: null,
  company: null
}

export const mutations = {
  SET_COMPANIES(state, companies) {
    state.companies = companies.data
    state.meta = companies.meta
  },
  SET_COMPANY(state, company) {
    state.company = company
  }
}

export const actions = {
  getCompanies({ commit, dispatch }, query) {
    let newQuery = build_query(
      query,
      allowedFilters,
      !_.isUndefined(query.include) ? query.include : allowedIncludes,
      !_.isUndefined(query.sort) ? query.sort : allowedSorts,
      null
    )
    return new Promise((resolve, reject) => {
      CompanyService.getCompanies(newQuery)
        .then(response => {
          commit('SET_COMPANIES', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: COMPANY_ERROR_MESSAGES.getCompaniesError + ' ' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getCompanyByCui({ commit, dispatch }, cui) {
    return new Promise((resolve, reject) => {
      CompanyService.getCompanyByCui(cui)
        .then(response => {
          commit('SET_COMPANY', response.data)
          resolve(response.data)
        })
        .catch(err => {
          if (err.response.data.errors.hasOwnProperty('cui') === false) {
            const notification = {
              type: 'danger',
              message: COMPANY_ERROR_MESSAGES.getCompanyByCuiError + ' ' + errorMessage(err)
            }
            dispatch('notification/add', notification, {
              root: true
            })
          }

          reject(err)
        })
    })
  }
}
